export enum CompanyBidApprovalType {
  ByEmail = 'אישור במייל',
  BySignature = 'אישור חתום',
  BטProcurement = 'הזמנת רכש',
  PersonalAgreement = 'הסכם אישי'
}
